// /report-a-problem — same shell as /contact-us but with the category
// dropdown promoted to required and posting to /api/support.

import { ContactShell } from "./contact-us.tsx";

export function ReportAProblemPage() {
  return (
    <ContactShell
      kind="support"
      eyebrowKey="support.eyebrow"
      titleKey="support.title"
      subtitleKey="support.subtitle"
      panelTaglineKey="support.panel.tagline"
      replyWindowKey="support.panel.reply_window"
      submitEndpoint="/api/support"
      categoryRequired
    />
  );
}
